import { createContext, useContext, useState, useCallback, useEffect, ReactNode } from "react";

interface InteractiveWindowContextValue {
  count: number;
  register: () => () => void;
}

const InteractiveWindowContext = createContext<InteractiveWindowContextValue | null>(null);

export function InteractiveWindowProvider({ children }: { children: ReactNode }) {
  const [count, setCount] = useState(0);

  const register = useCallback(() => {
    setCount((c) => c + 1);
    return () => setCount((c) => c - 1);
  }, []);

  return <InteractiveWindowContext.Provider value={{ count, register }}>{children}</InteractiveWindowContext.Provider>;
}

/** Returns true if dialogs should be modal (no interactive windows open) */
export function useDialogModal(): boolean {
  const context = useContext(InteractiveWindowContext);
  // If no provider, default to modal=true (normal behavior)
  return context ? context.count === 0 : true;
}

/** Call in DraggableWindow to register when open */
export function useRegisterInteractiveWindow(isOpen: boolean) {
  const context = useContext(InteractiveWindowContext);

  useEffect(() => {
    if (!context || !isOpen) return;
    return context.register();
  }, [context, isOpen]);
}
